
module.exports.listaUsuarios = [
    {
     id: 'hf6tyhj7df6ujhu76df67df' ,
     username: 'jlarab',
     fecUltModificacion: '01/01/2021',
     correoElectronico: 'junior.lara@rimac.com.pe',
     tipoUsuario: 'interno',
     estado: 'activo',
     accion: '1'
    },
    {
        id: 'hfhj75t6ydf6df67kjndf' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'activo',
        accion: '1'
       },
       {
        id: 'hfq2hj7df66yu8df67df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'activo',
        accion: '1'
       },
       {
        id: 'hfhj7dfaqw6df467df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'activo',
        accion: '1'
       },
       {
        id: 'hfhj74rtydf6df687df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'activo',
        accion: '1'
       },
       {
        id: 'hfhj7dwf6dfr6u767df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'inactivo',
        accion: '1'
       },
       {
        id: 'hfhj7dsaf6dfr67df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'activo',
        accion: '1'
       },
       {
        id: 'hfhj7df6df6fgr47df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'inactivo',
        accion: '1'
       },
       {
        id: 'hf4fghj7df6df67df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'activo',
        accion: '1'
       },
       {
        id: 'hfhj7df6d4rf67df' ,
        username: 'jlarab',
        fecUltModificacion: '01/01/2021',
        correoElectronico: 'junior.lara@rimac.com.pe',
        tipoUsuario: 'interno',
        estado: 'inactivo',
        accion: '1'
       }

];